export const AUTH = "AUTHORIZATION:AUTH"
export const LOGOUT = "AUTHORIZATION:LOGOUT"
export const REFRESH_TOKEN = "AUTHORIZATION:REFRESH_TOKEN"
